module.exports = __webpack_public_path__ + "static/media/SF-11-A (1).dc242036.mp3";